jQuery( function($) {
    $(document).ready( function() {

        let searchParams = new URLSearchParams(window.location.search);

        if(searchParams.has('trial') ){
            $('.trial').next().click();

            let trial_img = $(".single-product-media__images").find(`[data-is-trial=true]`).find('.gallery-img img');
            let imgURL = trial_img.attr("src");

            $(".single-product-media__main-img img").attr('src',imgURL);

        }

    });
});